export default __webpack_public_path__ + "905f58df4c3ad21ca78d93cfd8b6733c.ttf";